export default str => str.toString().replace(/[^0-9\.]/g, '');
